export default function (LoadSaveService, $q, TranslateService) {
    var translateFn = TranslateService.instant;

    function whatStepCanBeSkipped(claim) {
        return claim.policy && claim.lossCause && claim.lossDate;
    }

    var ACTION_MSG = {
        createClaim: {
            error: {
                title: 'fnol.general.config.FlowConfig.Error creating claim',
                message: 'fnol.general.config.FlowConfig.An error occurred attempting to create a claim.'
            },
            progress: {
                message: 'fnol.general.config.FlowConfig.Creating draft claim...'
            }
        }
    };

    var ACTIONS = {
        createClaim: function createClaim(_ref) {
            var claim = _ref.value;

            if (claim.claimNumber) {
                return LoadSaveService.saveClaim(claim);
            }

            return LoadSaveService.createClaim(claim);
        }
    };

    return function (step, junction) {
        junction('generalSuccess');

        junction('generalError');

        step('generalWhat', true).onNext.doAction(function (model) {
            return ACTIONS.createClaim(model);
        }, ACTION_MSG.createClaim).thenBranch(function () {
            return 'generalWhere';
        }, function () {
            return 'generalError';
        }).skipOnResumeIf(whatStepCanBeSkipped).isValid(function (model) {
            return model.aspects.valid && model.aspects.subtreeValid;
        }).label(function () {
            return translateFn('fnol.wizard.step.general.What');
        });

        step('generalWhere').onNext.goTo('generalSuccess').skipOnResumeIf(function (_ref2) {
            var claim = _ref2.value;
            return claim.lossLocation && claim.lossLocation.city;
        }).isValid(function (model) {
            return model.aspects.valid && model.aspects.subtreeValid;
        }).label(function () {
            return translateFn('fnol.wizard.step.general.Where');
        });
    };
}


//////////////////
// WEBPACK FOOTER
// ./common/js/src/edge/fnol/general/config/FlowConfig.js
// module id = 1542
// module chunks = 0